import type { RoleModel } from '../models.ts'

export const OrganizationAdminRole: RoleModel = {
  name: 'Organization Admin',
  key: 'organization-admin',
  privileges: ['core', 'organization-admin'],
}

export const BrandRole: RoleModel = {
  name: 'Brand',
  key: 'brand',
  privileges: ['core', 'brand'],
}

export const AgencyRole: RoleModel = {
  name: 'Agency',
  key: 'agency',
  privileges: ['core', 'agency'],
}

export const InternalRole: RoleModel = {
  name: 'Internal',
  key: 'internal',
  privileges: ['core', 'organization-admin', 'internal'],
}

export const SystemRole: RoleModel = {
  name: 'System',
  key: 'system',
  privileges: ['all'],
}

export const AllRoles = [
  BrandRole,
  OrganizationAdminRole,
  AgencyRole,
  InternalRole,
  SystemRole,
]
